/**
 * Nombres de plantilla que el Worker puede inyectar (subset usado en el cliente).
 *
 * Política home (cf. `cloudflare-worker-delfuocampo/worker.js` → `COUNTRY_TEMPLATE_MAP`):
 *   - AR → `BaseTemplate` (UI: BaseTemplateBlack; CTA por provincia / heroCta admin)
 *   - Resto del mundo (DEFAULT) → `DualCTAVideoLanding` (Mux fullscreen + VIP/Free)
 *
 * `BaseTemplate` y `BaseTemplateBlack` comparten la misma UI en la home (BaseTemplateBlack).
 * `DualCTAVideoLanding` es self-contained: no usa `isBaseTemplateFamily`.
 */

/** Template de home que inyecta el Worker para cualquier país (mapa + default). */
export const WORKER_HOME_TEMPLATE = "BaseTemplate" as const;

const BASE_TEMPLATE_FAMILY = new Set([
  "BaseTemplate",
  "BaseTemplateBlack",
  // Override por país (CountryTemplateAdmin): home editorial intl. Comparte la
  // familia Base (hero CTA por flags geo / site-settings, no el par dual).
  "BaseTemplateInternational",
]);

export function isBaseTemplateFamily(templateName: string | null | undefined): boolean {
  return !!templateName && BASE_TEMPLATE_FAMILY.has(templateName);
}
